import {
  Button,
  Checkbox,
  ListItem as Slot,
  MobileDrawer as Drawer,
  Text,
  Trail,
  Typography,
} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {PaymentCard as PaymentCardItem} from './PaymentCard.mobile'
import {PaymentCardAdd} from './PaymentCardAdd.mobile'
import * as classes from './PaymentCardList.classes'
import {usePaymentCardList} from './PaymentCardList.hooks'
import {Props} from './PaymentCardList.types'

export const PaymentCardList = memo(function PaymentCardList(props: Props): React.ReactElement<Props> {
  const {fetchCardBoundContext, onAdd} = props
  const {
    addDisabled,
    cards,
    currentCard,
    changeHandler,
    translates,
    buttonProps,
    agreementProps,
    notificationsAgreementProps,
  } = usePaymentCardList(props)

  return (
    <>
      <Slot size="l">
        <Text>
          <Typography thickness="medium" variant="body1">
            {translates.title}
          </Typography>
          <Typography color="minor" mt="xs" variant="caption1">
            {translates.subtitle}
          </Typography>
        </Text>
      </Slot>
      <div />
      {cards.map(c => (
        <PaymentCardItem key={c.id} card={c} checked={c.id === currentCard?.id} onPress={changeHandler} />
      ))}
      <PaymentCardAdd disabled={addDisabled} fetchCardBoundContext={fetchCardBoundContext} onAdd={onAdd} />
      {notificationsAgreementProps && (
        <Slot
          className={classes.notificationsAgreement}
          dividerOffset="m"
          onPress={notificationsAgreementProps.onChange}
          size="l"
        >
          <Text>{notificationsAgreementProps.children}</Text>
          <Trail alignItems="start" mr="m">
            <Checkbox checked={notificationsAgreementProps.checked} onChange={notificationsAgreementProps.onChange} />
          </Trail>
        </Slot>
      )}
      {agreementProps && (
        <Slot className={classes.agreement} dividerOffset="m" onPress={agreementProps.onChange} size="l">
          <Text>{agreementProps.children}</Text>
          <Trail mr="m">
            <Checkbox
              checked={agreementProps.checked}
              error={agreementProps.error ? ' ' : undefined}
              onChange={agreementProps.onChange}
            />
          </Trail>
        </Slot>
      )}
      <Drawer.Footer className={classes.footer}>
        <Button {...buttonProps} fullWidth>
          {translates.button}
        </Button>
      </Drawer.Footer>
    </>
  )
})
